import general from "../general";
import React, { useEffect, useRef, useState } from "react";
import KeepScroll from "./KeepScroll";
import { useScroll, useSize, useThrottleFn } from "ahooks";
import { Link } from "react-router-dom";
import URI from "urijs";
import ActiveContext from "../lib/ActiveContext";
import $ from "jquery";
import useActiveState from "./useActiveState";
import { useLogin } from "./LoginContext";
import useUrlState from "@ahooksjs/use-url-state";
import { getKidCallback, userClickReport } from "../utils/kidCallback";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export const NavLink = (props) => {
  const [initProps, setInitProps] = useState({});
  const [newProps, setNewProps] = useState({});
  const { setShowLogin } = useLogin();

  let [params, setParams] = useUrlState({});

  useEffect(() => {
    setInitProps({ user: true, token: true, escape: false, ...props });
  }, [props]);

  useEffect(() => {
    let to = props.to;
    if (to) {
      to = URI(to)
        .addQuery("origin", "react")
        .addQuery("version", "1.0.1")
        .toString();

      if (localStorage.getItem("tgm_uuid")) {
        to = URI(to)
          .addQuery("uuid", localStorage.getItem("tgm_uuid"))
          .toString();
      }

      let agent = localStorage.getItem("agent") || params.agent || "x7z1";
      if (initProps.iframe && agent && !initProps.escape) {
        to = URI(to).addQuery("agent", agent).toString();
      }

      if (
        initProps.iframe &&
        localStorage.getItem("app") &&
        JSON.parse(localStorage.getItem("app")).brand
      ) {
        to = URI(to)
          .addQuery("brand", JSON.parse(localStorage.getItem("app")).brand)
          .toString();
      }

      if (initProps.iframe && localStorage.getItem("key")) {
        to = URI(to).addQuery("kid", localStorage.getItem("key")).toString();
      }

      if (initProps.iframe && initProps.token) {
        to = URI(to)
          .addQuery("username", localStorage.getItem("username"))
          .addQuery("token", localStorage.getItem("token"))
          .addQuery("userid", localStorage.getItem("user_id"))
          .toString();
      }

      const safeAreaBottom = $("#safeAreaInsetBottom").height();
      to = URI(to).addQuery("safearea", safeAreaBottom).toString();

      if (initProps.iframe) {
        let uri = URI("/iframe");
        uri.addQuery("url", to);

        if (initProps.iframe.title) {
          uri.addQuery("title", initProps.iframe.title);
        }

        if (initProps.iframe.topHidden) {
          uri.addQuery("topHidden", initProps.iframe.topHidden);
        }
        to = uri.toString();
      }
    }
    setNewProps({
      ...props,
      to: to ? to : "",
      iframe: null,
      user: null,
      token: null,
      escape: null,
      onClick: null,
    });
    // console.log("to===================", newProps);
  }, [initProps]);
  const [udid] = useActiveState("udid");
  const [require, setRequire] = useState();
  const onClick = (e) => {
    if (initProps.user && !general.isLogin()) {
      e.preventDefault();
      e.stopPropagation();

      sessionStorage.setItem("isHaveBack", "");
      setShowLogin(true);
      document.body.style.overflow = "hidden";
    } else {
      if (props.onClick) {
        props.onClick(e);
      }
    }
  };

  return (
    <>
      {require}
      {props.to ? (
        <>
          {newProps.to ? (
            <Link className={props.className} {...newProps} onClick={onClick}>
              {props.children}
            </Link>
          ) : (
            <a className={props.className} onClick={onClick}>
              {props.children}
            </a>
          )}
        </>
      ) : (
        <a className={props.className} {...newProps} onClick={onClick}>
          {props.children}
        </a>
      )}
    </>
  );
};

export const NavView = (props) => {
  const [title, setTitle] = useState(props.title);
  const [colour, setColour] = useState();
  const [operate, setOperate] = useState();

  const location = useLocation();

  const { setIsFromLogin } = useLogin();

  const scroll = useScroll();
  const { run: _setColour } = useThrottleFn(
    (value) => {
      setColour(value);
    },
    { wait: 10 }
  );
  useEffect(() => {
    if (props.active && props.color) {
      if (scroll && scroll.top) {
        let opacity = Math.abs(scroll.top) / 40;
        if (opacity > 1) {
          opacity = 1;
        }
        _setColour("rgba(" + props.color + ", " + opacity + ")");
        // _setColour("rgba(" + props.color + ")");
      } else {
        _setColour("transparent");
        // _setColour("rgba(" + props.color + ")");
      }
    }
  }, [scroll, props.active]);

  const backRef = useRef();
  const operateRef = useRef();
  const backSize = useSize(backRef);
  const operateSize = useSize(operateRef);

  // useEffect(() => {
  //   if (operateSize?.width > backSize?.width) {
  //     if (backRef.current) {
  //       $(backRef.current).css("width", operateSize.width - 10);
  //     }
  //   }
  // }, [backSize, operateSize]);

  // 搜索词上报
  const searchBackClick = async () => {
    console.log("分类搜索开始点击");

    // 同步生成三级kid
    let kid = await getKidCallback();

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_time: dayjs().unix(),
      search_term: sessionStorage.getItem("boardInputFont"),
    };
    userClickReport({
      target_action_type: "search",
      parent_id: sessionStorage.getItem("boxSecondKid"),
      kid,
      level: 3,
      action_code: "search_input",
      remark: JSON.stringify(reamrk),
    });
    sessionStorage.removeItem("boardInputFont");
  };

  return (
    <ActiveContext.Provider value={props.active}>
      <KeepScroll active={props.active}>
        <div
          className={`nav-view ${props.invasion ? "invasion " : ""} ${
            props.active ? "active" : ""
          } ${props.className || ""}`}
          style={{ zIndex: props.index }}
        >
          {/*  || props.query.topHidden */}
          {props.topHidden ? null : (
            <div
              className={"nav-view-head width " + props.theme}
              style={colour ? { backgroundColor: colour } : null}
            >
              {props.statusBarBackground !== false ? (
                <div
                  className="status-bar-background"
                  style={{
                    backgroundImage: props.backColor
                      ? "linear-gradient(#202737, #202737)"
                      : "linear-gradient(rgba(204, 204, 204, 0.95), rgba(204, 204, 204, 0))",
                  }}
                />
              ) : null}
              <div className="container">
                {props.back !== false &&
                window.location.href.indexOf("backHidden") === -1 ? (
                  // ref={backRef}
                  <div
                    ref={backRef}
                    className="back"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: props.backColor ? props.backColor : "#3d3d3d",
                    }}
                    onClick={() => {
                      if (sessionStorage.getItem("boardInputFont")) {
                        // 未进行联想词下步操作 点击返回按钮 进行搜索词上报
                        console.log("未进行联想词下步操作点击返回按钮");
                        searchBackClick();
                      }
                      setIsFromLogin(false);

                      // 设置一个标记，表示这是通过点击返回按钮触发的
                      sessionStorage.setItem("isFromBackButton", "true");

                      if (window.location.href.indexOf("&gohome=1") > -1) {
                        general.history.push("/");
                      } else {
                        general.history.goBack();
                      }
                    }}
                  >
                    {location.pathname == "/task/day" ||
                    location.pathname == "/task/novice" ? (
                      <img
                        src="/resources/common/back-white.png"
                        alt=""
                        style={{ width: "32px" }}
                      />
                    ) : (
                      <img
                        src="/resources/common/back.png"
                        alt=""
                        style={{ width: "32px" }}
                      />
                    )}
                  </div>
                ) : null}
                <div className="title">{title}</div>
                <div className="operate" ref={operateRef}>
                  {operate}
                </div>
              </div>
            </div>
          )}

          {/*  || props.query.topHidden */}
          <div
            className="nav-view-body"
            style={{
              background: props.background,
              paddingTop:
                props.topHidden || props.invasion
                  ? 0
                  : "calc(env(safe-area-inset-top) + 48px)",
            }}
          >
            <props.component
              active={props.active}
              action={props.action}
              query={props.query}
              setTitle={setTitle}
              setColour={setColour}
              setOperate={setOperate}
            />
          </div>
        </div>
      </KeepScroll>
    </ActiveContext.Provider>
  );
};

export default {};
